import { Boss } from './Boss';
import { BasicAlien } from '../monsters/BasicAlien';
import Phaser from 'phaser';

export class SummonerBoss extends Boss {
  private summonCooldown: number = 4000; // 4s
  private lastSummonTime: number = 0;
  private minionsPerSummon: number = 3;

  constructor(scene: Phaser.Scene, x: number, y: number) {
    super(scene, x, y);
    this.health = 350;
    this.maxHealth = 350;
    this.speed = 24;
    this.reward = 220;
    this.specialAbility = 'Summon Minions';
    // Visual: boss tím
    const circle = scene.add.circle(0, 0, 20, 0x9c27b0);
    circle.setName('bossCircle');
    this.add(circle);
  }

  override activateAbility(): void {
    // const now = this.scene.time.now;
    // if (now - this.lastSummonTime > this.summonCooldown) {
    //   this.lastSummonTime = now;
    //   this.summonMinions();
    // }
  }

  private summonMinions(): void {
    for (let i = 0; i < this.minionsPerSummon; i++) {
      const angle = Math.random() * Math.PI * 2;
      const offset = 40;
      const x = this.x + Math.cos(angle) * offset;
      const y = this.y + Math.sin(angle) * offset;
      const minion = new BasicAlien(this.scene, x, y);
      this.scene.add.existing(minion);
    }
    this.showSummonEffect();
  }

  private showSummonEffect(): void {
    const circle = this.getByName('bossCircle');
      if (circle instanceof Phaser.GameObjects.Graphics) {
      circle.clear();
      circle.fillStyle(0xffffff);
      circle.fillCircle(0, 0, 20);
      this.scene.time.delayedCall(120, () => {
        circle.clear();
        circle.fillStyle(0x9c27b0);
        circle.fillCircle(0, 0, 20);
      });
    } else if (circle instanceof Phaser.GameObjects.Arc) {
      circle.setFillStyle(0xffffff);
      this.scene.time.delayedCall(120, () => {
        circle.setFillStyle(0x9c27b0);
      });
    }
  }
} 